<div *ngIf="!showRequest">
    <h2 class="sectionTitle">{{'FRONT_USER.LOGIN_FORM.LOGINFORM' | translate }}</h2>
</div>
<div *ngIf="!showRequest" class="">
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <div class="form-container">
            <div class="form-group">
                <label for="username">{{ 'FRONT_USER.LOGIN_FORM.USER_NAME' | translate}}</label>
                <span class="red"> *</span>
                <input type="text" formControlName="username" id="username" name="username" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.username?.errors }" (keydown.space)="$event.preventDefault();" />
                <div *ngIf="submitted ||(f.username?.dirty && f.username?.errors)" class="red ">
                    <div *ngIf="f.username?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                    <div *ngIf="f.username?.errors?.pattern">
                        {{'FRONT_USER.AGENT_REGISTRATION_FORM.AGENT_REPRESENTATIVE_FORM.NAME_EMAIL_ERROR' | translate}}
                    </div>
                    <div *ngIf="f.username?.errors?.startsWithSpaceError">
                        {{'FRONT_USER.START_WITH_SPACE' | translate}}
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="password">{{'FRONT_USER.LOGIN_FORM.PASSWORD'| translate}}</label>
                <span class="red"> *</span>
                <input type="password" formControlName="password" id="password" name="password" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && f.password?.errors }" />
                <div *ngIf="submitted || (f.password?.dirty && f.password?.errors)" class="red">
                    <div *ngIf="f.password?.errors?.required">{{'FRONT_USER.This_Field_Is_Required'| translate}}</div>
                </div>
            </div>
            <div *ngIf=" counter > 5 ">
                <div class="form-group">
                    <label for="recaptcha">{{ 'FRONT_USER.REGISTRATION_FORM.CAPTCHA' | translate}}</label>
                    <span class="red"> *</span>
                    <ngx-recaptcha2 #captchaElem [siteKey]="sitekey" [useGlobalDomain]="false"
                        formControlName="recaptcha" [hl]="lang">
                    </ngx-recaptcha2>
                    <div *ngIf="submitted || (f.recaptcha?.dirty && f.recaptcha?.errors)" class="red ">
                        <div *ngIf="f.recaptcha?.errors?.required">{{ 'FRONT_USER.This_Field_Is_Required' | translate}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <p class="btns-holder">
            <button (click)="checkstate()"
                class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.LOGIN_FORM.LOGIN' | translate}}</button>
            
            <a routerLink="/resetpassword">
                {{ 'FRONT_USER.LOGIN_FORM.FORGET_PASSWORD' | translate}}
            </a>
            
            <span>|</span>
            <a routerLink="/register">
                {{ 'FRONT_USER.REGISTRATION_FORM.REGISTER' | translate}}
            </a>
            
            <span *ngIf="isAgent">|</span>
            <a *ngIf="isAgent" class="dropdown-item bold" (click)="ResendActivation()">
                {{'FRONT_USER.LOGIN_FORM.GET_ANOTHER_CODE'|translate}}
            </a>
            
            <span *ngIf="isSupplierAllowedtoResendConfirmMail">|</span>
             <a *ngIf="isSupplierAllowedtoResendConfirmMail" class="dropdown-item bold" (click)="ResendSupplierActivation()">
                {{'FRONT_USER.LOGIN_FORM.RESEND_SUPPLIER_CONFIRM_EMAIL'|translate}}
             </a>
        </p>
    </form>
</div>
<!-- Confirmation -->
<div *ngIf="showRequest" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path
                        d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                    </path>
                </g>
            </g>
        </svg>
        <p>{{ 'FRONT_USER.LOGIN_FORM.RESEND_ACTIVATION_SUCCESS' | translate }}</p>
    </div>
</div>